import { TranslationContext } from "models/translation";
import { useContext } from "react";

export const useTranslate = () => {
  const translate = useContext(TranslationContext);
  return translate.translate;
};

// returns the whole translation json
export const useTranslations = () => {
  const translate = useContext(TranslationContext);
  return translate.translations;
};
